import { EPermissoes } from '@/enums/ePermissoes';

export default [
  {
    description: 'Classificacao',
    path: 'classificacao',
    name: 'classificacao',
    component: () => import('@/views/gestao/classificacao/Index.vue'),
    goesToMenu: true,
    meta: {
      permissions: [EPermissoes.CadastrosBase],
      grupos: [],
      escopoObra: 'global'
    }
  },
  {
    description: 'Inclusao de Classificacao',
    path: 'classificacao/incluir',
    parent: 'classificacao',
    name: 'classificacaoinsert',
    component: () => import('@/views/gestao/classificacao/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'classificacao',
      permissions: [EPermissoes.CadastrosBase],
      grupos: []
    }
  },
  {
    description: 'Edicao de Classificacao',
    path: 'classificacao/editar/:id',
    parent: 'classificacao',
    name: 'classificacaoupdate',
    component: () => import('@/views/gestao/classificacao/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'classificacao',
      permissions: [EPermissoes.CadastrosBase],
      grupos: []
    }
  }
];
